export default __webpack_public_path__ + "static/media/aboutimg.eaafab37.png";